import React, { useState } from 'react';

function ReadMore({
  text, maxTextLength, moreLinkText, children,
}) {
  const [expanded, setExpanded] = useState(false);

  const moreLinkClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setExpanded(state => !state);
  };

  const textTruncated = text &&
    text.length >= maxTextLength &&
    `${text.substr(0, text.lastIndexOf(' ', maxTextLength))}...`;

  return (
    <div className="mn_readMoreInfo">
      {textTruncated && !expanded ?
        <span>
          <span dangerouslySetInnerHTML={{ __html: textTruncated }} />
          <button className="mn_moreLink" onClick={moreLinkClick}>{moreLinkText}</button>
        </span> :
        <>
          <span dangerouslySetInnerHTML={{ __html: text }} />
          { children }
        </>
        }
    </div>
  );
}

export default ReadMore;
